import { ReactElement } from 'react';

import { PrintTemplateMarkAsFavoriteCommand } from '@dreryk/egabinet-document-template-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import {
   dispatchSnackbarPositiveEvent,
   HeartIcon,
   IconFillColor,
   IconWrapper,
   Tooltip,
} from '@dreryk/react-components';

import { consentTemplateActionTranslationKeys } from '../../../../../../translations';

const t = consentTemplateActionTranslationKeys.modal.form.table.options.markAsFavorite;

type ConsentTemplateMarkAsFavoriteIconProps = {
   readonly printTemplateId: number;
   readonly onMarkedAsFavorite: VoidFunction;
};

export const ConsentTemplateMarkAsFavoriteIcon = (props: ConsentTemplateMarkAsFavoriteIconProps): ReactElement => {
   const { executeAsync: markAsFavorite } = useCqrsCommand<void, unknown>(
      () => {
         const command = new PrintTemplateMarkAsFavoriteCommand();
         command.id = props.printTemplateId;
         return command;
      },
      {
         onSuccess: () => {
            props.onMarkedAsFavorite();
            dispatchSnackbarPositiveEvent(t.successMessage);
         },
      }
   );

   return (
      <Tooltip testId={'markAsFavorite'} content={t.tooltipMessage}>
         <IconWrapper onClick={markAsFavorite} testId={'markAsFavorite'} fillColor={IconFillColor.PRIMARY_LIGHTER}>
            <HeartIcon />
         </IconWrapper>
      </Tooltip>
   );
};
